<template>
  <v-layout
    wrap
    justify-center
    class="activity"
    style="padding: 0px !important;"
  >
    <v-flex 
      v-if="logo && logo.length > 0"
      :style="{ 'background-color': `${backgrounColor}` }"
      xs12
    >
      <img
        :src="logo"
        width="100%"
        heigth="auto"
        alt="logo"
      >
    </v-flex>
    <v-flex
      v-if="!hideHead"
        xs12
        style="padding: 0px; 10px; 0px; 10px;"
        >
        <div
          v-if="title && title.length > 0"
          :style="{ 'background-color': `${color1 ? color1 : backgrounColor}`, 'line-height': subtitle && subtitle.length > 0 ? '1' : '1', 'padding-top': (logo && logo.length > 0) ? '0px' : '40px', 'padding-bottom': subtitle && subtitle.length > 0 ? '0px' : '40px' }"
          style="font-size: 22px;color:white;text-align: center !important;padding: 20px;"
        >
          {{ title.toUpperCase() }}
        </div>
    </v-flex>
    <v-flex
        xs12
        style="padding: 0px; 0px; 0px; 0px;"
        v-if="subtitle && subtitle.length > 0"
      >
        <div
          :style="{ 'background-color': `${backgrounColor}` }"
          style="padding-top: 0px; padding-bottom: 20px;font-size: 12px;color:white;text-align: center !important;"
           v-html="subtitle"
        />
    </v-flex>
    <v-flex
      xs12
      style="padding-bottom: 0px;padding-top: 0px;padding-left: 20px;padding-right: 20px;"
    >
      <div
        style="font-size: 22px;text-align: center !important; "
        :style="{ 'color': color3 ? color3 : '#666', 'padding-top': hideHead ? '20px' : '15px', 'padding-bottom': hideHead ? '20px' : '15px' }"
      >
        {{ $t(sDay.pre).toUpperCase() }} {{ $t(sDay.month).toUpperCase() }} {{ $t(sDay.pos).toUpperCase() }}
      </div>
      <div>
      <div
        v-if="!player"
        style="opacity: 0.8;position: static; height:64px;top:0px;margin-bottom:20px;"
        :style="{ 'background-color': `${configColor.BGColor}` }"
      >
        <table border="0" style="width:100%;height:100%;border:0px;" cellspacing="0" cellpadding="0">
          <tr>
            <td class="td" v-for="(day, index) in week" 
            :key="`td${index}`"
            :style="{ 'background-color': daysToAdd === index ? color2 ? color2.concat('80') : backgroundColor03 : color2 ? color2 : configColor.BGColor, 'border-right': index !== 6 ? '1px solid white' : '0px' }" 
            style="text-align: center;color:white;width:14.19%"
            @click="() => handleAddDays(index)"
          >
              {{ $t(`common.${day}`).substring(0, 2) }}
            </td>
          </tr>
        </table>
      </div>
      <!-- <div
        style="position: static;top:0px;margin-top:-64px;"
      >
        <v-toolbar
          v-if="week && week.length > 0"
          style="background-color:transparent;padding: 0px !important;margin: auto !important;margin-bottom:20px;"
        >
          <v-spacer
          />
          <template
            v-for="(day, index) in week"
          >
            <v-btn
              :key="`b${index}`"
              icon
              style="padding: 0px !important;width:20px; color:white; "
              @click="() => handleAddDays(index)"
            >
              {{ $t(`common.${day}`).substring(0, 1) }}
            </v-btn>
            <v-spacer
              :key="`sb${index}`"
            />
            <v-divider
              v-if="index < (week.length - 1)"
              :key="`d${index}`"
              :style="{ 'border-color': 'white' }"
              vertical
              style="margin:0px !important;"
            />
            <v-spacer
              v-if="index < (week.length - 1)"
              :key="`sa${index}`"
            />
          </template>
        </v-toolbar>
      </div> -->
      </div>
      <v-container
        fluid
        grid-list-md
      >
        <v-layout
          row
          wrap
          style="margin-bottom: 20px;"
        >
          <v-flex
            v-if="!loading && (!activities || activities.length === 0)"
            :style="{ 'background-color': configColor.ColorContent, 'color': configColor.BGColorContent }"
            style="margin: 15px;text-align: center;padding-top:10px;padding-bottom:10px;opacity:0.9;"
          >
            {{ $t('messages.noActivities').toUpperCase() }}
          </v-flex>
          <v-flex v-if="pages && activities">
            <v-carousel
              cycle
              interval="2000"
                  :height="130 * rows"
              hide-delimiter-background
              touchless
              :next-icon="false"
              :prev-icon="false"
              hide-delimiters
            >
              <v-carousel-item
                v-for="(page, i) in activitiesPages"
                :key="i"
                elevation="0"
              >
                <v-sheet
                  color="transparent"
                  height="100%"
                  elevation="0"
                >
                <v-layout wrap>
                <v-flex
                  v-for="(activity, index) in page"
                  :key="activity.ID"
                  v-bind="{ [`xs${isDesktop ? 6 : 12}`]: true }"
                  style="margin-top: 5px;margin-bottom: 6px;padding:10px;"
                >
            <activity-item 
              :activity="activity"
              :color1="color1"
              :color2="color2"
              :color3="color3"
              :color4="color4"
              :color6="color6"
              :daysToAdd="daysToAdd"
              :configColor="configColor"
              :backgrounColor="backgrounColor"
              :totem="totem"
              :isSimulation="isSimulation"
            />

                </v-flex>
                </v-layout>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
          <v-flex
            v-else
            v-for="(activity, index) in activities"
            :key="activity.ID"
            v-bind="{ [`xs${isDesktop ? 6 : 12}`]: true }"
            style="margin-top: 5px;margin-bottom: 6px;"
            :style="{ 'padding-right': index % 2 === 0 && isDesktop ? '10px' : '0px', 'padding-left': index % 2 !== 0 && isDesktop ? '10px' : '0px' }"
          >
            <activity-item 
              :activity="activity"
              :color1="color1"
              :color2="color2"
              :color3="color3"
              :color4="color4"
              :color6="color6"
              :daysToAdd="daysToAdd"
              :configColor="configColor"
              :backgrounColor="backgrounColor"
              :totem="totem"
              :isSimulation="false"
            />
              <!--
            <v-card
              style="border-radius:5px;height:100%;"
              :style="{ 'opacity': activity.Availability.finished ? '0.3' : '1'}"
            >
              <v-layout
                row
                wrap
                style="height:100%;"
              >
                <v-flex
                  xs4
                  style="padding: 0;height:100%;"
                >
                  <v-img
                    :src="activity.Image"
                    :lazy-src="activity.Image"
                    :style="{ 'margin-left': isSimulation ? '10px' : '0px'}"
                    height="100%"
                    width="90%"
                    aspect-ratio="1.7"
                    class="grey lighten-2"
                    style="border-radius: 5px 0 0px 5px;"
                  />
                </v-flex>
                <v-flex
                  :style="{ 'color': configColor.ColorContent}"
                  xs8
                >
                  <v-layout
                    row
                    wrap
                    style="margin-top:5px;margin-bottom:0px;"
                  >
                    <v-flex
                      xs8
                      style="text-align: left;padding-bottom:5px;line-height:1.2;"
                      :style="{ 'color' : color3 ? color3 : '#666666'}"
                    >
                      {{ activity.Title.toUpperCase() }}
                    </v-flex>
                    <v-flex
                      xs4
                      style="text-align: right;padding-right: 15px;padding-bottom:0px;"
                    >
                      <add-calendar
                        v-if="!totem && activity && !activity.Availability.finished"
                        :start="activity.Date"
                        :end="activity.Date"
                        :startTime="activity.TimeStart"
                        :endTime="activity.TimeEnd"
                        :title="activity.Title"
                        :description="activity.Description ? activity.Description : ''"
                        :color="`${color3 ? color3 : backgrounColor}`"
                        :active="daysToAdd === 0 && activity.Availability.time"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      style="text-align: left;padding-top: 0px;padding-bottom: 0px;"
                    >
                      <v-icon
                        dark
                        class="activity-button"
                        style="margin-left: 0px;font-weight: 500;font-size: 20px;"
                        :style="{ 'color': activity.Availability.time && activity.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : color2 ? color2 : '#666666'}"
                      >
                        mdi-clock-outline
                      </v-icon>
                      <span
                        style="font-weight: 500;font-size: 20px;"
                        :style="{ 'color': activity.Availability.time && activity.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : color2 ? color2 : '#666666'}"
                      >
                        {{ activity.TimeStart.substring(0, 5) }}-{{ activity.TimeEnd.substring(0, 5) }}
                      </span>
                    </v-flex>
                    <v-flex
                      xs12
                      style="text-align: left;padding-top: 0px;padding-bottom: 7px;"
                    >
                      <span                  
                        :style="{ 'opacity': activity.Description && activity.Description.length > 0 ? '1' : '0'}"
                        style="font-size: 13px;color: #999999;"
                        v-html="activity.Description && activity.Description.length > 0 ? activity.Description : '.'"
                      >
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>-->
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
     <v-flex
        xs12
        style="padding: 0px; 10px; 0px; 10px;"
      >
        <div
          v-if="title && title.length > 0"
          style="padding-left: 20px; padding-right:20px;padding-top: 0px; padding-bottom: 10px;font-size: 14px;color:#666666;text-align: center !important;"
          v-html="note"
        />
    </v-flex>
    <v-flex
      xs12
      style="padding: 0px; 10px; 0px; 10px;"
    >
      <div
        v-if="title && title.length > 0"
        style="padding-top: 0px; padding-bottom: 30px;font-size: 12px;color:#666666;text-align: center !important;opacity:0.5"
      >
        Powered by <b>Descubre Group®</b>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import AddCalendar from './AddCalendar'
import ActivityItem from './ActivityItem'
import utils from '@/services/utils'
import acttiv from '@/services/acttiv'
import i18n from '@/plugins/i18n'
import axios from 'axios'
export default {
  name: 'Activities',
  components: {
    AddCalendar,
    ActivityItem,
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: null
    },
    isDesktop: {
      type: Boolean,
      required: false,
      default: false
    },
    isSecundary: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: Number,
      required: false,
      default: 0
    },
    isSimulation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      title: null,
      note: null,
      configColor: {
        BGColorSecundary: 'transparent',
        ColorSecundary: 'transparent',
        BGColor: 'transparent',
        Color: 'transparent'
      },
      backgrounColor: 'transparent',
      backgroundColor03: 'transparen',
      logo: null,
      subtitle: null,
      enterprise: null,
      data: {},
      activities: [],
      activitiesPages: null,
      typeActivity: 0,
      typesActivity: null,
      week: [],
      daysToAdd: 0,
      pages: null,
    }
  },
  computed: {
    link () {
      // console.log('id', utils.getParameterByName('id'))
      return utils.getParameterByName('id')
    },
    urlLocale () {
      let aux = utils.getParameterByName('locale')
      if (!aux || aux.length <= 0) aux = 'es'
      return aux.toLowerCase()
    },
    hideHead () {
      return utils.getParameterByName('hh') === 'true'
    },
    color1 () {
      return utils.getParameterByName('c1') ? `#${utils.getParameterByName('c1')}`: null
    },
    color2 () {
      return utils.getParameterByName('c2') ? `#${utils.getParameterByName('c2')}`: null
    },
    images () {
      return utils.getParameterByName('images') ? utils.getParameterByName('images'): 'default'
    },
    color3 () {
      return utils.getParameterByName('c3') ? `#${utils.getParameterByName('c3')}`: null
    },
    color4 () {
      return utils.getParameterByName('c4') ? `#${utils.getParameterByName('c4')}`: null
    },
    color5 () {
      return utils.getParameterByName('c5') ? `#${utils.getParameterByName('c5')}`: null
    },
    color6 () {
      return utils.getParameterByName('c6') ? `#${utils.getParameterByName('c6')}`: null
    },
    acttiv () {
      return utils.getParameterByName('acttiv') 
    },
    totem () {
      return utils.getParameterByName('totem') === 'true'
    },
    player () {
      return utils.getParameterByName('player') === 'true'
    },
    rows () {
      return utils.getParameterByName('f') ? utils.getParameterByName('f') | 0 : null
    },
    carousel () {
      return utils.getParameterByName('carousel') === 'true'
    },
    addDays () {
      return utils.getParameterByName('addDays') ? (utils.getParameterByName('addDays') | 0) : 0
    },
    urlActivityType () {
      const aux = utils.getParameterByName('Act')
      return aux && aux.length > 0 ? aux : 0
    },
    locale () {
      return i18n.locale
    },
    sDay () {
      let dToday = new Date()
      const dActual = new Date().setDate(dToday.getDate() + this.daysToAdd)
      const pos = `${new Date(dActual).getDate()}, ${new Date(dActual).getFullYear()}`

      const result = {
        pre: this.daysToAdd === 0 ? 'common.today' : this.daysToAdd === 1 ? 'common.tomorrow' : '',
        month: `common.m${new Date(dActual).getMonth()}`,
        pos
      }
      return result
    }
  },
  watch: {
  },
  mounted () {
    if (this.color5) document.getElementById('app').style.backgroundColor = `${this.color5}`
    //this.daysToAdd = this.addDays
    i18n.locale = this.urlLocale
    this.typeActivity = this.urlActivityType
    const dSemenaActual = new Date().getUTCDay() - 1
    const aux = []
    for (let i = 0; i < 7; i++) {
      const x = ((dSemenaActual + i) >= 7) ? (dSemenaActual + i - 7) : dSemenaActual + i
      aux.push(`s${x}`)
    }
    this.week = aux

    // this.enterprise = utils.getActiveEnterprise()
    this.handleAddDays(this.addDays)
    //this.handleGetActivities(this.daysToAdd)
  },
  methods: {
    prepareRows (v) {
      this.pages = null
      if (!this.rows || (this.rows * 2) >= v.length) return v
      else {
        const aux = v.length/(this.rows*2)
        this.pages = (aux | 0) + (aux % 1 > 0 ? 1 : 0) // aux % 1 get decimal
        const activityPages = []
        let a = []
        let pos = 0
        for(const act of v) {
          pos++
          a.push(act)
          if(pos === this.rows*2) {
            activityPages.push(a)
            pos = 0
            console.log('jhm', a)
            a = []
          }
        }
        if (a.length > 0) activityPages.push(a)
        /*for (let i = 0; i < this.pages; i++) {
          const auxLimit = (this.rows*2) > v.length ? v.length : (this.rows*2)
          console.log('jhm1', v.length, this.pages,  this.rows * i * 2, auxLimit)
          activityPages.push(v.slice((2 * i*this.rows),this.rows*2))
        }
        */
        console.log('jhm2', activityPages, this.pages)
        this.activitiesPages = activityPages
        return v
      }
    },
    onChange (action, aux) {
      this.data.T5_TypeActivity = this.typeActivity
      this.$emit('input', this.data)
    },
    handleAddDays (value) {
      this.loading = true
      this.daysToAdd = value
      if (this.acttiv) this.handleGetActtivActivities(this.daysToAdd)
      else this.handleGetActivities(this.daysToAdd)
    },
    handleGetTypeActivities (daysToAdd = 0) {
      this.data = axios.get(`https://www.dviewcontent.com/api/p_activity/${this.link}/dtouch-type-activity`)
        .then(response => {
          this.typesActivity = [
            {
              ID: 0,
              Name: 'TODOS'
            },
            {
              ID: 1,
              Name: response.data.TypeActivity01 && response.data.TypeActivity01.length > 0 ? response.data.TypeActivity01 : 'Type 01'
            },
            {
              ID: 2,
              Name: response.data.TypeActivity02 && response.data.TypeActivity02.length > 0 ? response.data.TypeActivity02 : 'Type 02'
            },
            {
              ID: 3,
              Name: response.data.TypeActivity03 && response.data.TypeActivity03.length > 0 ? response.data.TypeActivity03 : 'Type 03'
            }
          ]
        })
    },
    getSelectedDate () {
      let aux = new Date()
      aux = new Date (aux.setDate(aux.getDate() + this.daysToAdd))
      return this.formatDate(aux)
    },
    formatDate(date, short) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear()
  
      if (month.length < 2) 
          month = '0' + month
      if (day.length < 2) 
          day = '0' + day
  
      if (short) return [day, month].join('/')
      else return [year, month, day].join('-')
    },
    firstDay () {
      let aux = new Date()
      aux = new Date (aux.setDate(aux.getDate() + this.daysToAdd))
      var day = aux.getDay(),
          diff = aux.getDate() - day + (day == 0 ? -6 : 1) // adjust when day is sunday
      return this.formatDate(new Date(aux.setDate(diff)))
    },
    replaceAll(string, search, replace) {
      return string ? string.split(search).join(replace) : ''
    },
    getIsActive(st, et) {
      const result = st <= new Date() && et >= new Date()
      return result
    },
    getIsOld(value) {
      return value < new Date() ? true : false
    },
    prepareImage(v) {
      let url = `https://www.dviewcontent.com/activity/acttiv/images/${this.images}${this.totem || this.player ? '' : '_dtouch'}/${this.formatImageName(v.nombre_tarea)}.jpg`
      
      if (!utils.urlExists(url)) 
        url = `https://www.dviewcontent.com/activity/acttiv/images/${this.images}${this.totem || this.player ? '' : '_dtouch'}/${v.codigo_categoria_actividad}.jpeg`

      const isPos20 = (new Date(v.hora_inicio).toTimeString().slice(0, 2) | 0) >= 20
      if (!utils.urlExists(url) && isPos20) url = `https://www.dviewcontent.com/activity/acttiv/images/${this.images ? this.images : 'default'}/404.jpg`

      return url
    },
    formatImageName (value) {
      let aux = value
      aux = this.replaceAll(aux, ' ', '')
      aux = this.replaceAll(aux, '-', '')
      aux = this.replaceAll(aux, '_', '')
      aux = this.replaceAll(aux, 'á', 'a')
      aux = this.replaceAll(aux, 'é', 'e')
      aux = this.replaceAll(aux, 'í', 'i')
      aux = this.replaceAll(aux, 'ó', 'o')
      aux = this.replaceAll(aux, 'ú', 'u')
      aux = this.replaceAll(aux, 'ñ', 'n')
      return aux.toLowerCase()
    },
    convertPias (data) {
      this.backgrounColor = '#ED652D';
      let allActivities = null
      const pia = data
      this.title = pia.nombre_hotel
      const result = []
      for (const program of pia.programa_hotel) {          
        const programs = []
        for (const plan of program.dia_planif) {
          const result_plan = {
            
            Events: []
          }
          for (const tar of plan.tarea_pia) {
            const title = tar.nombre_tarea
            const name = {
              es: tar.nombre_tarea_es ? tar.nombre_tarea_es : tar.nombre_tarea,
              en: tar.nombre_tarea_en,
              de: tar.nombre_tarea_de,
              fr: tar.nombre_tarea_fr,
            }
            const startTime = new Date(tar.hora_inicio.replace(/-/g, '/'))
            const endTime = new Date(tar.hora_fin.replace(/-/g, '/'))
            
            if (plan.fecha === this.formatDate(this.getSelectedDate())) {
              result.push({
                TareaPiaID: tar.id_tarea_pia,
                ProgramID: program.id_programa_hotel,
                ProgramName: program.nombre_programa,
                Date: plan.fecha,
                Name: name,
                Title: title,
                Start: startTime,
                End: endTime,
                TimeLimit: tar.plazo_reserva_minutos && tar.plazo_reserva_minutos !== -1 ? new Date(startTime.getTime() + (-1 * tar.plazo_reserva_minutos) * 60000) : null,
                RangeTime: `${startTime.toTimeString().slice(0,5)} - ${endTime.toTimeString().slice(0,5)}`,
                //ImageURL: `https://dviewcontent.com/activity/acttiv/images/${this.hotelID}_dtouch/${this.formatImageName(title)}.jpg`,
                ImageURL: this.prepareImage(tar), // `https://dviewcontent.com/activity/acttiv/images/${'default'}_dtouch/${this.formatImageName(title)}.jpg`,
                CategoryID: tar.codigo_categoria_actividad,
                Category: tar.nombre_categoria_actividad,
                IsActive: this.getIsActive(startTime, endTime),
                IsOLD: this.getIsOld(endTime),
                Availability: tar.disponibilidad_actual,
                MaxCapacity: tar.aforo_max,
                RequiresReservation: tar.requiere_reserva,
                RequiresAcceptPolicy: tar.aceptar_politica,
                AdultsOnly: tar.para_adultos && !tar.para_ninos,
                KidsOnly: tar.para_ninos && !tar.para_adultos,
                AdultsAndKids: tar.para_ninos && tar.para_adultos
              })
            }
          }
        }
      }
      allActivities = result.slice().sort((a, b) => {
        return a.Start - b.End
      })
      this.backgrounColor = this.color1
      this.activities = this.prepareRows(allActivities.map(item => {
        return {
          // Title: item.Title,
          Title: utils.getTranslation(item.Name, this.locale),
          Image: item.ImageURL,
          TimeStart: `${utils.pad(item.Start.getHours())}:${utils.pad(item.Start.getMinutes())}:${item.Start.getSeconds()}`,
          TimeEnd: `${utils.pad(item.End.getHours())}:${utils.pad(item.End.getMinutes())}:${item.End.getSeconds()}`,
          //TimeEnd: item.End,
          Availability: {
            finished: item.IsOld,
          },
          Description: item.Category,
        }
      }))
      //this.fitlerPias()
      // this.activities = this.allActivities
      this.loading = false  
    },
    handleGetActtivActivities (daysToAdd = 0) {
      this.activities = []
      const https = require('https')
      const agent = new https.Agent({  
        rejectUnauthorized: false
      })
      const baseURL = 'https://intranet.acttiv.es/api-pias/v1'
      const login = {
        login: 'Descubre',
        pass: 'LSqfnVdFuiA'
      }

      axios.put(`${baseURL}/session/login`, login, {
        httpsAgent: agent
      })
      .then(response => {
        const token = response.data.token
        let mainError = null
        try {
          const pia = axios.get(`${baseURL}/pias/pia?idHotel=${this.acttiv}&fecha=${this.firstDay()}`, {
            headers: {
              'Content-type': 'application/json; charset=UTF-8', // Indicates the content
              'Authorization': `Bearer ${token}`
            },				
            httpsAgent: agent,			
          })
          .then (response => {
          
          this.convertPias(response.data)
        
          axios.delete(`${baseURL}/session/logout`, {
            headers: {
              'Content-type': 'application/json; charset=UTF-8', // Indicates the content
              'Authorization': `Bearer ${token}`
            },				
            httpsAgent: agent,			
          })

          })
          .catch ( () => {
            this.loading = false
          })
        }
        catch (error) { 
          console.log('jhm1',error.message)
          axios.delete(`${baseURL}/session/logout`, {
            headers: {
              'Content-type': 'application/json; charset=UTF-8', // Indicates the content
              'Authorization': `Bearer ${token}`
            },				
            httpsAgent: agent,			
          })
          this.loading = false
          return { error: true, value: error.message }
        }

      })
      /*
        const pias = acttiv.getPias(this.acttiv, this.firstDay())
        console.log(pias)
      return
        const url = `https://www.dtouch.es/public/acttiv/token`
        axios.get(url)
        .then(response => {

          const token = response.data.token

          const url = `https://www.dtouch.es/public/acttiv/pias?token=${token}&hotelID=${this.acttiv}&date=${this.firstDay()}`
          const that = this
          axios.get(url)
          .then(response => {
            console.log(url,response)
            if (!response.data.error) console.log('pias', response.data)//this.convertPias(response.data)
            else that.loading = false
          })
            .catch((err) => {
              console.log(err)
            that.loading = false
          })
          //this.getActtivConfig()
        })
        .catch((error) => {      
          console.log(error)
        })*/
      /*
      this.activities = axios.get(`https://www.dviewcontent.com/api/p_activity/${this.link}/dtouch?config=true&daysToAdd=${daysToAdd}&type=${this.typeActivity}`)
        .then(response => {
          if (response.data) {
            const aux = response.data.activities
            for (let i = 0; i < aux.length; i++) {
              aux[i].Title = utils.getTranslation(aux[i].Title, this.locale)
              aux[i].Description = utils.getTranslation(aux[i].Description, this.locale)
            }
            console.log('jhm', response.data.activities)

            this.title = utils.getTranslation(response.data.config.Title, this.locale)
            this.note = utils.getTranslation(response.data.config.Note, this.locale)
            this.configColor.BGColor = response.data.config.Color02
            this.backgrounColor = response.data.config.Color01
            this.backgroundColor03 = response.data.config.Color03
            this.logo = response.data.config.ActivityLogoMobile
            this.subtitle = response.data.config.ActivitySubtitleMobile
            this.activities = aux
          } else {
            this.activities = []
          }
        })
        */
    },
    handleGetActivities (daysToAdd = 0) {
      this.activities = axios.get(`https://www.dviewcontent.com/api/p_activity/${this.link}/dtouch?config=true&daysToAdd=${daysToAdd}&type=${this.typeActivity}`)
        .then(response => {
          if (response.data) {
            const aux = response.data.activities
            for (let i = 0; i < aux.length; i++) {
              aux[i].Title = utils.getTranslation(aux[i].Title, this.locale)
              aux[i].Description = utils.getTranslation(aux[i].Description, this.locale)
            }
            //console.log('jhm', response.data.activities)

            this.title = utils.getTranslation(response.data.config.Title, this.locale)
            this.note = utils.getTranslation(response.data.config.Note, this.locale)
            this.configColor.BGColor = response.data.config.Color02
            this.backgrounColor = response.data.config.Color01
            this.backgroundColor03 = response.data.config.Color03
            this.logo = response.data.config.ActivityLogoMobile
            this.subtitle = response.data.config.ActivitySubtitleMobile
            this.activities = this.prepareRows(aux)
          } else {
            this.activities = []
          }
          this.loading = false
        })
    }
  }
}
</script>
<style>
.activity .container {
  padding: 0px;
}
.layout.activity.justify-center {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.activity .v-toolbar__content {
  padding: 0px !important;
  margin: auto !important;
}
.activity-button {
  margin-left: 10px;
}
.activity-button:hover {
  /* opacity: 0.7; */
}
.td:hover {
  cursor: pointer;
}
.v-carousel {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
